import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService implements CanActivate{
	isUser = (window as any).authenticated;
	constructor(public router: Router) {
	}

	canActivate(): boolean {
		if (!this.isUser) {
			window.location.href = '/login';
			return true;
		}
		return true;
	}

	checkLogin(val){
		return this.isUser = val;
	}
}
